import cx from 'classnames';
import { Button, Offcanvas } from 'react-bootstrap';
import Loader from '../../components/Loader/Loader';
import { CLOSE_ICON } from '../../constants/assetConstants';
import Image from '../Image';
import styles from './EditPopupUI.module.scss';
import { icons } from '../../assets';
const { CloseIconSmall } = icons;

export const EditPopupUI = ({
  showDefaultHeader = false,
  showCustomHeader = true,
  showCloseButton = false,
  show,
  onClose,
  loading,
  thumbnail,
  hideThumbnail,
  className = '',
  title,
  subtitle,
  username,
  children,
  backdropClassName = '',
  backdrop = true,
  theme = '',
  closeButtonPosition = 'fixed',
  customCloseIcon = null,
  placement = 'end',
  bodyClassName= '',
}) => {
  const closeButton = (
    <button className={styles.closeButton} onClick={onClose}>
      <Image src={CLOSE_ICON} />
    </button>
  );

  const CustomCloseIcon = customCloseIcon;

  return (
    <Offcanvas
      show={show}
      onHide={onClose}
      placement={placement}
      className={cx(styles.root, className, theme && styles[`theme${theme}`])}
      onClose={onClose}
      backdropClassName={backdropClassName}
      backdrop={backdrop}>
      {showDefaultHeader && !showCustomHeader && (
        <Offcanvas.Header className="align-items-top sidebarHeader">
          <Offcanvas.Title className="fullWidth">
            <div className="heading-user-title">
              <h4 className="m-0 ellipsis">{title}</h4>
              {subtitle}
            </div>
          </Offcanvas.Title>
          {CustomCloseIcon ? (
            <CustomCloseIcon width={16} height={16} onClick={onClose} />
          ) : (
            <Button className="modalCloseButton textureCloseButton" onClick={onClose}>
              <CloseIconSmall width={17} height={17} />
            </Button>
          )}
        </Offcanvas.Header>
      )}

      {((showCustomHeader && !showDefaultHeader) || showCloseButton) &&
        closeButtonPosition === 'fixed' &&
        closeButton}

      <Offcanvas.Body className={bodyClassName}>
        <Loader loading={loading} />
        {showCustomHeader && !showDefaultHeader && (
          <header className={styles.header}>
            {!hideThumbnail && (
              <Image
                src={thumbnail}
                containerProps={{ className: styles.thumbnail }}
                placeholderWhileLoading
                ratio={1}
                rounded
              />
            )}

            <div>
              <div className={styles.title}>{title}</div>
              <div className={styles.headerInfo}>
                {username ? <>{username} &#x2022; </> : ''}
                {subtitle}
              </div>
            </div>

            {closeButtonPosition === 'header' && closeButton}
          </header>
        )}
        {children}
      </Offcanvas.Body>
    </Offcanvas>
  );
};
